import { Pencil, Shield } from "lucide-react";
import { useState } from "react";
import SsoConfigDisplay from "@/bizminer/Admin/Organizations/_components/sso/SsoConfigDisplay.tsx";
import SsoEditDialog from "@/bizminer/Admin/Organizations/_components/sso/SsoEditDialog.tsx";
import { useSsoTestConnection } from "@/bizminer/Admin/Organizations/_components/sso/useSsoTestConnection.ts";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { BizminerAdminSsoConfig } from "@/types/serializers";

interface Props {
  organizationId: number;
  ssoConfig: BizminerAdminSsoConfig;
}

export default function SsoConfigCard({ organizationId, ssoConfig }: Props) {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const { testStatus, handleTestConnection } = useSsoTestConnection({
    organizationId,
    ssoConfig,
  });

  return (
    <>
      <Card>
        <CardHeader className="border-b flex-row items-center justify-between space-y-0">
          <div className="flex items-center gap-2">
            <Shield className="h-5 w-5 text-primary" />
            <CardTitle className="text-lg">Single Sign-On</CardTitle>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsEditOpen(true)}
          >
            <Pencil className="h-4 w-4 mr-1" />
            Edit
          </Button>
        </CardHeader>
        <CardContent className="pt-4">
          <SsoConfigDisplay
            ssoConfig={ssoConfig}
            testStatus={testStatus}
            onTestConnection={handleTestConnection}
          />
        </CardContent>
      </Card>

      {isEditOpen && (
        <SsoEditDialog
          onClose={() => setIsEditOpen(false)}
          organizationId={organizationId}
          ssoConfig={ssoConfig}
        />
      )}
    </>
  );
}
